





































































































































































































































































































































































































































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import VReservation from "@/shared/models/vReservation";
import { reservationStatuses } from "@/shared/models/vReservation";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { saveFile } from "@/shared/saveFile";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import DateField from "@/components/misc/DateField.vue";
import ReservationModal from "@/components/reservation-form/ReservationModal.vue";
import * as _ from "lodash";
import { Notification } from "../store/modules/notifications";
import NoData from "@/components/misc/NoData.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";
import { Action, Getter } from "vuex-class";
import { ReservationStatusEnum, TenantTypesEnum, DistributionChannelEnum, ReservationsGridDefaultFilterByEnum, InvoiceStatusEnum } from "@/shared/models/enums.type";
import TableCellUnitTypeDisplay from "@/components/misc/TableCellUnitTypeDisplay.vue";
import { DistributionChannelType } from "@/shared/models/distributionChannelType";
import { DistributionChannelTypesEnum } from "./reservation-form/types";
import { ReservationBillingStatus } from '@/shared/models/reservationStatus';

@Component({
  components: {
    SortableHeadersTable,
    DateField,
    ReservationModal,
    NoData,
    RequireRole,
    TableCellUnitTypeDisplay,
  },
})
export default class ReservationsTable extends Vue {
  settingsOpen = false;
  reservationsTags: string[] = [];
  tagSeparator = "\r\n";

  @Getter("auth/claims") claims?: JwtClaims;
  get allowedToModifyReservations() {
    return policyChecker("MODIFY_RESERVATIONS")(this.claims);
  }
  get isAllowedToSeePrices() {
    return (
      policyChecker("MODIFIED_PRICES")(this.claims) ||
      policyChecker("ACTUAL_PRICES")(this.claims) ||
      policyChecker("OWNER_LEVEL_3")(this.claims)
    );
  }
  get isAllowedToExportReservations() {
    return policyChecker("EXPORT_RESERVATIONS")(this.claims);
  }

  get isAllowedToSeePhoneNumber() {
    return (
      policyChecker("GRID_TELEPHONE_NUMBER")(this.claims)
    );
  }

  get isAllowedDistributionOrSalesChannel() {
    return policyChecker("READ_DISTRIBUTION_AND_SALES_CHANNEL")(this.claims);
  }

  get isOwnerLevel3() {
    return policyChecker("OWNER_LEVEL_3")(this.claims);
  }

  get isOwnerLevel1() {
    return policyChecker("OWNER_LEVEL_1")(this.claims);
  }

  get isAllowedToSeeGuestRemarks(){
    return policyChecker("RESERVATION_GUEST_REMARKS")(this.claims);
  }

  get isAllowedToSeeOwnerRemarks(){
    return policyChecker("RESERVATION_REMARKS_FOR_OWNER")(this.claims);
  }

  get isAllowedToSeePropertyStaffRemarks(){
    return policyChecker("RESERVATION_PROPERTY_STAFF_REMARKS")(this.claims);
  }

  get isAllowedToSeeUnitMaintenanceRemarks(){
    return policyChecker("RESERVATION_UNIT_MAINTENANCE_STAFF_REMARKS")(this.claims);
  }

  get isAllowedToSeeGeneralMaintenanceStaffRemarks(){
    return policyChecker("RESERVATION_MAINTENANCE_STAFF_REMARKS")(this.claims);
  }

  ownerLevel3CanEdit(item: VReservation) {
    if ((policyChecker("OWNER_LEVEL_3")(this.claims) &&
      item.distributionChannelTypeId === DistributionChannelEnum.OwnersReservation) ||
      !policyChecker("OWNER_LEVEL_3")(this.claims)){
      return false;
    }
    return true;
  }

  DistributionChannelTypeEnum = DistributionChannelEnum;
  InvoiceStatusEnum = InvoiceStatusEnum;

  @Getter("appParams/reservationShowHolderInfo") showHolderInfo?: boolean;
  @Getter("appParams/reservationShowGuestInfo") showGuestInfo?: boolean;
  @Getter("appParams/reservationsGridFiltersByDate") reservationsGridFiltersByDate?: number;

  @Getter("reservations/dateFilterApplied") dateFilterApplied?: boolean;

  @Getter("appParams/typeId") tenantTypeId?: number;

  async created(){
    const promises = [];

    if ((this.reservationsTags?.length ?? 0) === 0) {
      promises.push(this.getTags());
    }

    if (
      (this.reservationBillingStatuses?.length ?? 0) === 0 &&
      this.refreshReservationBillingStatuses
    ) {
      promises.push(this.refreshReservationBillingStatuses());
    }

    await Promise.all(promises);
  }

  @Getter("codebooks/distributionChannelTypes")
  distributionChannelTypes?: DistributionChannelType[];
  
  @Action("codebooks/refreshReservationBillingStatuses")
  refreshReservationBillingStatuses?: () => Promise<void>;
  @Getter("codebooks/reservationBillingStatuses")
  reservationBillingStatuses?: ReservationBillingStatus[];

  get isTenantTypeAgency(){
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  @Watch("dateFilterApplied", { immediate: true })
  applyDateFilterSwitch() {
    this.options.page = 1
    this.load()
  }

  @Watch("claims.roles", { immediate: true })
  rolesWatch() {
    this.headers = [
      {
        text: "Period",
        value: "period",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["arrivalDate", "departureDate", "numberOfNights"],
      },
      {
        text: "Reservation.ArrivalDate",
        value: "arrivalDate",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["arrivalDate"],
      },
      {
        text: "Reservation.DepartureDate",
        value: "departureDate",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["departureDate"],
      },
      ...(this.showHolderInfo
        ? [
          {
            text: "Reservation holder",
            value: "reservationHolderName",
            active: true,
            default: false,
            class: "resize-header",
            exportHeaders: ["reservationHolderName"],
          },
        ]
        : []),
      ...(this.isAllowedToSeePhoneNumber
        ? [
          {
            text: "Telephone number",
            value: "reservationHolderTelephoneNumber",
            active: true,
            default: false,
            exportHeaders: [],
          },
        ]
        : []),
      ...(this.showGuestInfo
        ? [
          {
            text: "Guest",
            value: "reservationGuestName",
            active: true,
            default: false,
            class: "resize-header",
            exportHeaders: ["reservationGuestName"],
          },
        ]
        : []),
      {
        text: "Accomodation unit",
        value: "accomodationUnitTypeName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [
          "accomodationUnitTypeName",
          "accomodationUnitName",
          "propertyName",
        ],
      },
      {
        text: "Reservation status",
        value: "statusId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["statusName"],
      },
      ...(!this.isOwner
        ? [
          {
            text: "ReservationBillingStatus.BillingStatus",
            value: "ReservationInvoiceStatusTextResourceKey",
            active: true,
            default: false,
            class: "resize-header",
            exportHeaders: ["invoiceStatusName, amountToInvoice"],
              },
          ]
        : []),
      {
        text: "Reservation Id",
        value: "reservationId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["reservationId"],
      },
      ...(this.isAllowedToSeePrices
        ? [
          {
            text: "Total price",
            value: "totalPrice",
            active: true,
            default: false,
            class: "resize-header",
            exportHeaders: ["totalPrice", "currencyCode"],
          },
        ]
        : []),
      {
        text: "Booking date",
        value: "bookingDate",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["bookingDate"],
      },
      {
        text: "Cancelation date",
        value: "cancelationDate",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["cancelationDate"],
      },
      {
        text: "Reservation.IsCancelledWithinFreeCancellationPeriod",
        value: "isCancelledWithinFreeCancellationPeriod",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["isCancelledWithinFreeCancellationPeriod"]
      },
      ...(this.isAllowedDistributionOrSalesChannel
        ? [
          {
            text: "Sales channel",
            value: "otachannelName",
            active: true,
            default: false,
            class: "resize-header",
            exportHeaders: ["otachannelName", "otareservationId"],
          },
          {
            text: "DistributionChannel",
            value: "distributionChannelTypeId",
            active: false,
            default: false,
            class: "resize-header",
            exportHeaders: ["distributionChannelType"],
          },
          {
            text: "ReservationTable.OtaChannelComission",
            value: "otaChannelComission",
            active: false,
            default: false,
            class: "resize-header",
            exportHeaders: ["otaChannelComission", "currencyCode"],
          },
        ]
        : []),
      ...(this.allowedToModifyReservations
        ? [
          {
            text: "Option expiration",
            value: "optionExpirationDate",
            active: true,
            default: false,
            class: "resize-header",
            exportHeaders: ["optionExpirationDate"],
          },
        ]
        : []),

      {
        text: this.$t('Reservation.Tags').toString(),
        value: "tags",
        active: true,
        default: false,
        sortable: false,
        class: "resize-header",
        exportHeaders: ["tags"],
      },

      ...(this.isTenantTypeAgency && !this.isOwnerLevel3 ? [{
        text: "ReservationTable.OwnerTotalPrice",
        value: "ownerTotalPrice",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["ownerTotalPrice", "currencyCode"],
      },]: []),
      {
        text: "Total guests",
        value: "totalGuests",
        sortable: false,
        active: !this.allowedToModifyReservations,
        default: false,
        class: "resize-header",
        exportHeaders: ["totalGuests"],
      },
      {
        text: "Expected arrival time",
        value: "expectedArrivalTime",
        sortable: false,
        active: !this.allowedToModifyReservations,
        default: false,
        class: "resize-header",
        exportHeaders: ["expectedArrivalTime"],
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];
  }

  headers: SortableTableHeader[] = [];

  expandedRow: SortableTableHeader = {
    text: "Remarks",
    value: "expandedRow",
    active: true,
    default: false,
    exportHeaders: ["remarksForOwner"], // placeholder, real values are set on export call
  };

  filters = {
    reservationId: "",
    arrivalOrDepartureDate: "",
    bookingDate: "",
    cancellationDate: "",
    isCancelledWithinFreeCancellationPeriod: null as boolean | null,
    arrivalDateFromPeriod: "",
    arrivalDateToPeriod: "",
    departureDateFromPeriod: "",
    departureDateToPeriod: "",
    optionExpirationDate: "",
    reservationHolderName: "",
    reservationGuestName: "",
    accomodationUnitName: "",
    otachannelName: "",
    isFilteredByDate: null as boolean | null,
    distributionChannelTypeId: null as number | null,
    reservationTags: [] as string[],
    reservationInvoiceStatusIds: [] as string[],
    statusIds: [] as string[],
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  get serviceArrivalPeriod() {
    const res = [
      this.filters.arrivalDateFromPeriod
        ? this.filters.arrivalDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.filters.arrivalDateToPeriod
        ? this.filters.arrivalDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set serviceArrivalPeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.arrivalDateFromPeriod = val.length > 0 ? val[0] : "";
      this.filters.arrivalDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.arrivalDateFromPeriod = "";
      this.filters.arrivalDateToPeriod = "";
    }
  }

  get serviceDeparturePeriod() {
    const res = [
      this.filters.departureDateFromPeriod
        ? this.filters.departureDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.filters.departureDateToPeriod
        ? this.filters.departureDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set serviceDeparturePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.departureDateFromPeriod = val.length > 0 ? val[0] : "";
      this.filters.departureDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.departureDateFromPeriod = "";
      this.filters.departureDateToPeriod = "";
    }
  }

  get rules() {
    return {
      maxLength: (value: string) =>
        !value ||
        value.length <= 2000 ||
        this.$t("Validation.MaxLength", { count: 2000 }),
    };
  }

  async getTags() {
    const promises = [];

    promises.push(
      Vue.axios.get<any[]>(
        `reservations/GetTenantReservationTags`
      )
    );

    const [tags] = await Promise.all(promises);

    this.reservationsTags = tags.data;
  }

  get getSortedTags(){
    return this.reservationsTags?.sort((a,b) => a.localeCompare(b)) ?? [];
  }

  @Ref("editDialog") editDialog?: {
    validate: () => boolean;
  };

  saveRemark(item: VReservation) {
    const dialogValid = this.editDialog?.validate();
    if (!dialogValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Reservation.RemarksLenght",
        timeout: 5000,
        localize: true,
      } as Notification);

      this.load();
      return;
    }
    Vue.axios
      .post(`/Reservations/UpdateReservationRemark`, {
        id: item.reservationId,
        propertyStaffRemarks: item.propertyStaffRemarks,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Reservations.RemarkEditSuccess"),
          timeout: 5000,
        } as Notification);
      });
  }

  reservationFormId: number | null = null;
  scrollId: string | null = null;
  reservationFormOpen = false;
  rowDoubleClick(e: MouseEvent, { item }: { item: VReservation }) {
    this.openItemDetails(item);
  }
  openItemDetails(item: VReservation) {
    if (!this.allowedToModifyReservations) {
      return;
    }

    this.reservationFormId = item.reservationId;
    this.scrollId = item.reservationAccUnitTypeId.toString();
    this.reservationFormOpen = true;
  }
  addItem() {
    if (!this.allowedToModifyReservations) {
      return;
    }

    this.reservationFormId = null;
    this.scrollId = null;
    this.reservationFormOpen = true;
  }
  distributionChannelName(value: number) {
    const name = this.distributionChannelTypes?.find(
      (x) => x.id == value
    )?.textResourceKey;
    return name ? this.$t(name) : "";
  }

  get allowedDistributionChannelTypes() {
    if (!this.distributionChannelTypes) {
      return [];
    }
    const types = _.cloneDeep(this.distributionChannelTypes);

    if (this.isTenantTypeAgency) {
      return types;
    }
    else {
      return types?.filter(
        channel => channel.id != DistributionChannelTypesEnum.OwnersReservation);
    }
  }

  deleteItem(item: VReservation) {
    if (!this.allowedToModifyReservations) {
      return;
    }

    this.$store.dispatch("showNotification", {
      id: item.reservationId,
      color: "warning",
      message: this.$t("DeleteConfirmation") + ` '${item?.reservationId}'`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item.reservationId);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deleteItemConfirm(id: number) {
    Vue.axios
      .delete(`/Reservations/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Reservations.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.load();
      });
  }

  openMessages(id: number) {
    this.$router.push({
      name: "Messages",
      query: {
        reservationId: id.toString(),
      },
    });
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["period"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  list: ListModel<VReservation & { idUniq: string }> = {
    count: 0,
    result: [],
  };
  get expanded() {
    if (this.expandedRow.active) {
      return this.list.result.filter(
        (x) =>
          (this.allowedToModifyReservations && !!x.propertyStaffRemarks) ||
          (!this.allowedToModifyReservations &&
            (!!x.propertyStaffRemarks ||
              !!x.remarksForOwner ||
              !!x.guestRemarks ||
              !!x.generalMaintenanceStaffRemarks ||
              !!x.unitMaintenanceStaffRemarks))
      );
    } else {
      return [];
    }
  }

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<typeof ReservationsTable.prototype.list> {
    this.loading = true;
    return this.axios
      .get<ListModel<VReservation>>("/reservations", {
        params: this.queryParams
      })
      .then((res) => {
        this.list = {
          result: res.data.result.map((x) => ({
            ...x,
            reservationGuestName:
              x.reservationGuestName && x.reservationGuestName.length > 0
                ? x.reservationGuestName
                : x.reservationGuestPlaceholder,
            idUniq: `${x.reservationId}:${x.reservationAccUnitTypeId}`,
          })),
          count: res.data.count,
        };
        return this.list;
      })
      .finally(() => {
        this.scrollToTop();
        this.loading = false;
      });
  }

  get isOwner() {
    return policyChecker("IS_OWNER_ROLE")(this.claims);
  }

  exportToExcel() {
    this.loading = true;

    // values are set here so allowedToModifyReservations get the right data
    this.expandedRow.exportHeaders = [];
    if (this.isAllowedToSeeGuestRemarks) {
      this.expandedRow.exportHeaders.push("guestRemarks");
    }
    if (this.isAllowedToSeeOwnerRemarks) {
      this.expandedRow.exportHeaders.push("remarksForOwner");
    }
    if (this.isAllowedToSeePropertyStaffRemarks) {
      this.expandedRow.exportHeaders.push("propertyStaffRemarks");
    }
    if (this.isAllowedToSeeUnitMaintenanceRemarks) {
      this.expandedRow.exportHeaders.push("unitMaintenanceStaffRemarks");
    }
    if (this.isAllowedToSeeGeneralMaintenanceStaffRemarks) {
      this.expandedRow.exportHeaders.push("generalMaintenanceStaffRemarks");
    }

    return this.axios
      .get("reservations/export/excel", {
        params: {
          ...this.queryParams,
          $skip: 0,
          $top: null,
          headers: this.headers
            .concat(this.expandedRow)
            .filter((h) => h.active)
            .flatMap((h) => h.exportHeaders)
            .join(","),
        },
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "Reservations.xlsx");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get customerFilterData() {
    return (
      this.$router.currentRoute.query ?? {
        customerId: null,
        customerRole: null,
      }
    );
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      // "period" is the default sort so we use that to determine whether this is the initial load without user settings
      // and sort according to the parameter if so
      $orderby: formatOrderbyArray(
        this.options.sortBy[0] == "period"
          ? this.reservationsGridFiltersByDate == ReservationsGridDefaultFilterByEnum.ArrivalDate
            ? ["arrivalDate"]
            : ["departureDate"]
          : this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filtersForParams,
      ...this.customerFilterData,
      isFilteredByDate: this.dateFilterApplied
    };
  }

  get filtersForParams() {
    return {
      ...this.filters,
      tags: this.filters.reservationTags.length > 0 ? this.filters.reservationTags?.join(this.tagSeparator) : [],
      reservationInvoiceStatusIds: this.filters.reservationInvoiceStatusIds.length > 0 ? this.filters.reservationInvoiceStatusIds?.join(',') : [],
      statusIds: this.filters.statusIds.length > 0 ? this.filters.statusIds?.join(',') : []
  };
  }

  getTagsAsArray(tags: string){
    return tags?.split(this.tagSeparator + this.tagSeparator);
  }

  confirmMarkedAsManuallyOverriden(reservationId: number){
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("ReservationBillingStatus.MarkAsManuallyOverridenConfirm"),
      actions: [
        {
          text: this.$t("Confirm"),
          fun: () => {
            this.markAsManuallyOverriden(reservationId.toString());
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
 
  markAsManuallyOverriden(reservationId: string){
    this.loading = true;
    Vue.axios
      .put(`/reservations/MarkReservationsAsManuallyOverriden`,{
        reservationIds: reservationId
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("ReservationBillingStatus.MarkAsManuallyOverridenSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.loading = false;
        this.load();
      });
  }

  scrollToTop() {
    let scrollableWrapper: Element | null = null;

    if (this.$refs.dataTable instanceof Vue) {
      scrollableWrapper = (this.$refs.dataTable as Vue).$el.querySelector(
        ".v-data-table__wrapper"
      );
    } else if (this.$refs.dataTable instanceof Element) {
      scrollableWrapper = (this.$refs.dataTable as Element).querySelector(
        ".v-data-table__wrapper"
      );
    }

    if (scrollableWrapper) {
      scrollableWrapper.scrollTop = 0;
    }
  }

  getRowClass(item: VReservation) {
    let classes = "";
    if (item.distributionChannelTypeId === DistributionChannelEnum.OwnersReservation) {
      classes = "row-highlighted";
    }
    return classes;
  }

  get statuses() {
    if (this.allowedToModifyReservations) {
      return reservationStatuses;
    }

    return reservationStatuses.filter(
      (x) => x.id != ReservationStatusEnum.Canceled
    );
  }

  statusStyle(statusId: number) {
    return this.statuses.find((x) => x.id == statusId) ?? {};
  }

  isDayStay(item: VReservation) {
    return item.arrivalDate == item.departureDate;
  }
}
